<template>
    <div class="cb-header-secondary">
        <div class="cb-header-left">
            <div :class="['cb-expand-history', 'ai-tooltip-bottom', getItem('showChatHistory') ? 'hide': '']" :data-tooltip="$t('frm_ai_show_sidebar')" @click.prevent="handleShowHistory"></div>
        </div>
        <div class="cb-header-right">
            <div class="cb-versions" v-click-outside="clickOutsideActionConfig">
                <div v-if="getSelectedVersion" class="cb-selected-version"  @click="handleToggleVersionOptions">{{ $t('frm_version') }}: {{  getSelectedVersion.version }}</div>
                <div v-else class="cb-selected-version"  @click="handleToggleVersionOptions">{{ $t('frm_select_version') }}</div>
                <div v-if="getItem('showVersionOptions')" class="cb-version-list">
                    <ul v-if="Object.keys(getItem('versions')).length" class="version">
                        <li v-if="getSelectedVersion" @click="handleToggleVersionOptions">{{ $t('frm_version') }}: {{  getSelectedVersion.version }}</li>
                        <template v-for="(version, index) in getVersionsInDisplayOrder">
                            <li v-if="getItem('versionId') != version.versionId" :key="index" @click="handleSelectVersion(version)">{{ version.version }} </li>
                        </template>
                    </ul>
                    <div class="cb-version-action">
                        <div class="cb-version-collapse" @click="handleToggleVersionOptions"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import vClickOutside from 'v-click-outside';
    import { createNamespacedHelpers } from 'vuex';
    const { mapActions: aiChatMapActions, mapGetters: aiChatMapGetters } = createNamespacedHelpers('aichat')
    export default {
        name: "ChatHeaderSecondary",
        computed: {
            ...aiChatMapGetters([
                'getItem',
                'getSelectedVersion',
                'getVersionsInDisplayOrder'
            ])
        },
        data() {
            return {
                clickOutsideActionConfig: {
                    handler: this.clickOutSideVersionOptionsHandler,
                    events: ['click']
                }
            }
        },
        directives: {
            clickOutsideAction: vClickOutside.directive
        },
        methods: {
            ...aiChatMapActions([
                'setItem',
                'setUpNewChat'
            ]),
            handleSelectVersion(version) {
                if(this.getItem('loadChatMsgsProcessing') || 
                    this.getItem('loadMoreMsgsProcessing') || 
                    this.getItem('waitingReply')) {
                    return;
                }
                this.setUpNewChat();
                this.setItem({field: 'wizardStep', value: 'version-selection'});
                this.setItem({field: 'versionId', value: version.versionId});
                this.setItem({field: 'versionName', value: version.version});
            },
            handleToggleVersionOptions() {
                if(this.getItem('loadChatMsgsProcessing') || 
                    this.getItem('loadMoreMsgsProcessing') || 
                    this.getItem('waitingReply')) {
                    return;
                }
                this.setItem({field: 'showVersionOptions', value: !this.getItem('showVersionOptions')});
                if(!this.getItem('mainChatWindowExpanded')) {
                    this.setItem({field: 'showChatHistory', value: false});
                }
            },
            handleShowHistory() {
                this.setItem({field: 'showChatHistory', value: true});
            },
            clickOutSideVersionOptionsHandler () {
                this.setItem({field: 'showVersionOptions', value: false});
            },
        }
    }
</script>
